import _isPlainObject from 'lodash/isPlainObject';

export default {
  methods: {
    isLocaleObject(value) {
      return Array.isArray(value) || _isPlainObject(value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/i18n.js